<div
    class="settings--wrapper"
    data-testid="t-konto-div-1752672977568-21"
>
    <div
        class="title-bar"
        data-testid="t-konto-div-1752672977568-2"
    >
        <div
            class="title-bar--inner"
            data-testid="t-konto-div-1752672977568-1"
        >
            <h1
                class="h4"
                data-testid="t-konto-h1-1752672977568-1"
            >
                Einstellungen
            </h1>
        </div>
    </div>

    <div
        class="scrolling--col"
        data-testid="t-konto-div-1752672977568-20"
    >
        <div
            class="settings"
            data-testid="t-konto-div-1752672977568-19"
        >
            <div
                class="row g-3"
                data-testid="t-konto-div-1752672977568-15"
            >
                <div
                    class="col-12 col-md-6"
                    data-testid="t-konto-div-1752672977568-5"
                >
                    <div
                        class="content-box h-100"
                        data-testid="t-konto-div-1752672977568-4"
                    >
                        <h4
                            class="mb-3"
                            data-testid="t-konto-h4-1752672977568-1"
                        >
                            Schriftgröße
                        </h4>

                        <div
                            class="list-group"
                            data-testid="t-konto-div-1752672977568-3"
                        >
                            @for (fontsize of fontsizes; track fontsize; let i = $index) {
                                <button
                                    type="button"
                                    (click)="setFontSize(fontsize)"
                                    class="list-group-item list-group-item-action d-flex align-items-center"
                                    [class.active]="currentFontSize === fontsize + 'px'"
                                    data-testid="t-konto-button-1752672977568-1"
                                >
                                    <span
                                        class="oc-general-check me-2"
                                        [style.visibility]="currentFontSize === fontsize + 'px' ? 'visible' : 'hidden'"
                                        data-testid="t-konto-span-1752672977568-1"
                                    ></span>
                                    <span
                                        [ngClass]="{ 'text-muted': currentFontSize !== fontsize + 'px' }"
                                        [style.fontSize.px]="fontsize"
                                        data-testid="t-konto-span-1752672977568-2"
                                        >{{ fontsize }}px</span
                                    >
                                </button>
                            }
                        </div>
                    </div>
                </div>

                <div
                    class="col-12 col-md-6"
                    data-testid="t-konto-div-1752672977568-14"
                >
                    <div
                        class="content-box h-100"
                        data-testid="t-konto-div-1752672977568-13"
                    >
                        <h4
                            class="mb-3"
                            data-testid="t-konto-h4-1752672977568-2"
                        >
                            Themes
                        </h4>
                        <div
                            class="theme-oc-settings"
                            data-testid="t-konto-div-1752672977568-12"
                        >
                            <div
                                class="list-group"
                                data-testid="t-konto-div-1752672977568-11"
                            >
                                @for (theme of environmentService.themes; track theme; let i = $index) {
                                    <button
                                        type="button"
                                        (click)="overideTheme(i)"
                                        class="list-group-item list-group-item-action"
                                        [class.active]="theme.selected"
                                        aria-current="true"
                                        data-testid="t-konto-button-1752672977568-2"
                                    >
                                        <div
                                            class="d-flex align-items-center"
                                            data-testid="t-konto-div-1752672977568-10"
                                        >
                                            <span
                                                class="oc-general-check me-2"
                                                [style.visibility]="theme.selected ? 'visible' : 'hidden'"
                                                data-testid="t-konto-span-1752672977568-3"
                                            ></span>
                                            <span
                                                class="me-2"
                                                data-testid="t-konto-span-1752672977568-4"
                                                >{{ theme.desc }}</span
                                            >
                                            <div
                                                class="d-inline-flex ms-auto gap-1 align-items-center"
                                                data-testid="t-konto-div-1752672977568-9"
                                            >
                                                <div
                                                    class="oc-preview-color"
                                                    [style.backgroundColor]="theme.preview.color1"
                                                    data-testid="t-konto-div-1752672977568-6"
                                                ></div>
                                                <div
                                                    class="oc-preview-color"
                                                    [style.backgroundColor]="theme.preview.color2"
                                                    data-testid="t-konto-div-1752672977568-7"
                                                ></div>
                                                <div
                                                    class="oc-preview-color"
                                                    [style.backgroundColor]="theme.preview.color3"
                                                    data-testid="t-konto-div-1752672977568-8"
                                                ></div>
                                            </div>
                                        </div>
                                    </button>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div
                class="content-box mt-3"
                data-testid="t-konto-div-1752672977568-18"
            >
                <div
                    class="text-center"
                    data-testid="t-konto-div-1752672977568-16"
                >
                    <h4
                        class="mb-3"
                        data-testid="t-konto-h4-1752672977568-3"
                    >
                        Legende
                        <i
                            class="oc-legend ms-1"
                            data-testid="t-konto-i-1752672977568-1"
                        ></i>
                    </h4>
                </div>

                <div
                    class="table-oc-responsive table-responsive table-centered table-sm"
                    data-testid="t-konto-div-1752672977568-17"
                >
                    <table
                        class="table first-cell-auto-width"
                        data-testid="t-konto-table-1752672977568-1"
                    >
                        <thead data-testid="t-konto-thead-1752672977568-1">
                            <tr data-testid="t-konto-tr-1752672977568-1">
                                <th data-testid="t-konto-th-1752672977568-1">Icon</th>
                                <th data-testid="t-konto-th-1752672977568-2">Beschreibung</th>
                            </tr>
                        </thead>
                        <tbody data-testid="t-konto-tbody-1752672977568-1">
                            <tr data-testid="t-konto-tr-1752672977568-2">
                                <td data-testid="t-konto-td-1752672977568-1">
                                    <span
                                        class="oc-general-check"
                                        data-testid="t-konto-span-1752672977568-5"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-2">
                                    <span data-testid="t-konto-span-1752672977568-6">Bestätigen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-3">
                                <td data-testid="t-konto-td-1752672977568-3">
                                    <span
                                        class="oc-general-cancel"
                                        data-testid="t-konto-span-1752672977568-7"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-4">
                                    <span data-testid="t-konto-span-1752672977568-8">Abbrechen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-4">
                                <td data-testid="t-konto-td-1752672977568-5">
                                    <span
                                        class="oc-flyout"
                                        data-testid="t-konto-span-1752672977568-9"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-6">
                                    <span data-testid="t-konto-span-1752672977568-10">Navigationsleiste aus-/einfahren</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-5">
                                <td data-testid="t-konto-td-1752672977568-7">
                                    <span
                                        class="oc-gender-unknown"
                                        data-testid="t-konto-span-1752672977568-11"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-8">
                                    <span data-testid="t-konto-span-1752672977568-12">Optionen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-6">
                                <td data-testid="t-konto-td-1752672977568-9">
                                    <span
                                        class="oc-general-edit"
                                        data-testid="t-konto-span-1752672977568-13"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-10">
                                    <span data-testid="t-konto-span-1752672977568-14">Bearbeiten</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-7">
                                <td data-testid="t-konto-td-1752672977568-11">
                                    <span
                                        class="oc-statistics"
                                        data-testid="t-konto-span-1752672977568-15"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-12">
                                    <span data-testid="t-konto-span-1752672977568-16">Statistik anzeigen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-8">
                                <td data-testid="t-konto-td-1752672977568-13">
                                    <span
                                        class="oc-arrow-left"
                                        data-testid="t-konto-span-1752672977568-17"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-14">
                                    <span data-testid="t-konto-span-1752672977568-18">Seite zurück</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-9">
                                <td data-testid="t-konto-td-1752672977568-15">
                                    <span
                                        class="oc-glass"
                                        data-testid="t-konto-span-1752672977568-19"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-16">
                                    <span data-testid="t-konto-span-1752672977568-20">Pass anzeigen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-10">
                                <td data-testid="t-konto-td-1752672977568-17">
                                    <span
                                        class="oc-trash-can"
                                        data-testid="t-konto-span-1752672977568-21"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-18">
                                    <span data-testid="t-konto-span-1752672977568-22">Löschen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-11">
                                <td data-testid="t-konto-td-1752672977568-19">
                                    <span
                                        class="oc-plus"
                                        data-testid="t-konto-span-1752672977568-23"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-20">
                                    <span data-testid="t-konto-span-1752672977568-24">Hinzufügen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-12">
                                <td data-testid="t-konto-td-1752672977568-21">
                                    <span
                                        class="oc-danger"
                                        data-testid="t-konto-span-1752672977568-25"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-22">
                                    <span data-testid="t-konto-span-1752672977568-26">Achtung</span>
                                </td>
                            </tr>

                            <tr data-testid="t-konto-tr-1752672977568-13">
                                <td data-testid="t-konto-td-1752672977568-23">
                                    <span
                                        class="oc-heart-filled"
                                        data-testid="t-konto-span-1752672977568-27"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-24">
                                    <span data-testid="t-konto-span-1752672977568-28">Favorit</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-14">
                                <td data-testid="t-konto-td-1752672977568-25">
                                    <span
                                        class="oc-general-info"
                                        data-testid="t-konto-span-1752672977568-29"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-26">
                                    <span data-testid="t-konto-span-1752672977568-30">Information anzeigen</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-15">
                                <td data-testid="t-konto-td-1752672977568-27">
                                    <span
                                        class="oc-archive"
                                        data-testid="t-konto-span-1752672977568-31"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-28">
                                    <span data-testid="t-konto-span-1752672977568-32">Archivieren</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-16">
                                <td data-testid="t-konto-td-1752672977568-29">
                                    <span
                                        class="oc-padlock"
                                        data-testid="t-konto-span-1752672977568-33"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-30">
                                    <span data-testid="t-konto-span-1752672977568-34">Gesperrt</span>
                                </td>
                            </tr>
                            <tr data-testid="t-konto-tr-1752672977568-17">
                                <td data-testid="t-konto-td-1752672977568-31">
                                    <span
                                        class="oc-padlock-open"
                                        data-testid="t-konto-span-1752672977568-35"
                                    ></span>
                                </td>
                                <td data-testid="t-konto-td-1752672977568-32">
                                    <span data-testid="t-konto-span-1752672977568-36">Aktiv / Nicht gesperrt</span>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>
